import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import masterApi from '../../api/masters'

export interface RootState {
    version: string;
}

export class userNotification {
    counter!: number;
    notification: Array<notification> = [];
    totalPages!: number;
}
export class notification {
    color: string | undefined;
    message: string | undefined;
    comment: string | undefined;
    userName: string | undefined;
    time: string | undefined;
    status: number | undefined;
    orderId: number | undefined;
}
const state = {
    counter: 0,
    notification: [],
    totalPages: 0,
}
const getters: GetterTree<userNotification, RootState> = {
    notification(state: userNotification) {
        return state.notification
    }
};
export const mutations: MutationTree<userNotification> = {
    LOAD_NOTIFICATION(state: userNotification, notifications: Array<notification>) {

        notifications.forEach(element => {
            state.notification.push(element)
        });
    },
    UPDATE_PAGES(state: userNotification, pages: number) {
        state.totalPages = pages
    },
    ADD_NOTIFICATION(state: userNotification, notification: notification) {
        state.notification.push(notification)
        if (!state.counter) {
            state.counter = 1
        } else {
            state.counter += 1
        }

    },
    CLEAR_COUNTER(state: userNotification) {
        state.counter = 0
    },
    CLEAR_NOTIFICATION(state: userNotification) {
        state.notification.length = 0

    }
};
const actions: ActionTree<Array<notification>, RootState> = {

    addNotification({ commit }: { commit: Commit }, param: notification) {
        commit('ADD_NOTIFICATION', param)
    },

    async getNotification({ commit }: { commit: Commit }, params: string[]) {
        try {
            const response = await masterApi.getNotifications(params[0], params[1])
            if (response && response.data && response.data.resultType === 200) {
                const data = response.data.payload.payload
                    .map((e: { userName: any; time: any; status: any, color: any; comment: any; orderId: any; message: any; }) => {

                        const data = JSON.parse(e.message);
                        if (data.Web && data.Web.Message) {
                            return {
                                UserName: e.userName,
                                Time: e.time,
                                Status: e.status,
                                Color: data.Web.Color,
                                Comment: e.comment,
                                Message: data.Web.Message,
                                OrderId:e.orderId
                            }
                        } else {
                            return {
                                UserName: e.userName,
                                Time: e.time,
                                Comment: e.comment,
                                Message: "",
                            }
                        }


                    });
                if (params[0] == "1") {
                    commit('CLEAR_NOTIFICATION')
                }
                commit('UPDATE_PAGES', Math.ceil(response.data.payload.totalRecords / response.data.payload.pageSize))
                commit('LOAD_NOTIFICATION', data)
                return state;
            }
            else {
                return state;
            }
        }
        catch (error) {
            return state;
        }
    },
    clearNotification({ commit }: { commit: Commit }) {
        commit('CLEAR_NOTIFICATION')
    },
    clearCounter({ commit }: { commit: Commit }) {
        commit('CLEAR_COUNTER')
    }

}
export default {
    state,
    getters,
    mutations,
    actions
}